import { z } from 'zod';
import { I18nStringListSchema, I18nStringSchema, PartialI18nStringSchema } from './i18n';
export const CommentCategoryIconSchema = z.object({
    _id: z.string(),
    // Spanish is optional: most of the icon library is labelled in English only, and requiring it here would drop those icons from the picker entirely.
    altText: PartialI18nStringSchema,
    imageURL: z.string(),
    // Extra search terms for the icon picker, beyond the alt text
    keywords: I18nStringListSchema.default({})
});
export const CommentCategorySchema = z.object({
    id: z.string(),
    name: I18nStringSchema,
    description: I18nStringSchema.optional(),
    imgURL: z.string()
});
//# sourceMappingURL=commentCategory.js.map